/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { PaginatedLocationTagListAdmin } from './PaginatedLocationTagListAdmin'
import {
  PaginatedLocationTagListAdminFromJSON,
  PaginatedLocationTagListAdminFromJSONTyped,
  PaginatedLocationTagListAdminToJSON,
} from './PaginatedLocationTagListAdmin'

/**
 *
 * @export
 * @interface EnvelopedLocationTagListLocationTagListAdmin
 */
export interface EnvelopedLocationTagListLocationTagListAdmin {
  /**
   *
   * @type {PaginatedLocationTagListAdmin}
   * @memberof EnvelopedLocationTagListLocationTagListAdmin
   */
  body: PaginatedLocationTagListAdmin
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedLocationTagListLocationTagListAdmin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedLocationTagListLocationTagListAdmin interface.
 */
export function instanceOfEnvelopedLocationTagListLocationTagListAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedLocationTagListLocationTagListAdminFromJSON(
  json: any,
): EnvelopedLocationTagListLocationTagListAdmin {
  return EnvelopedLocationTagListLocationTagListAdminFromJSONTyped(json, false)
}

export function EnvelopedLocationTagListLocationTagListAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedLocationTagListLocationTagListAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: PaginatedLocationTagListAdminFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedLocationTagListLocationTagListAdminToJSON(
  value?: EnvelopedLocationTagListLocationTagListAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: PaginatedLocationTagListAdminToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
